module.exports = __webpack_public_path__ + "static/img/stcs.41a0fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stcs.jpg
// module id = wbtA
// module chunks = 0